import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
//import AppBar from 'material-ui/AppBar';
import Tabs from 'material-ui/Tabs/Tabs';
import Tab from 'material-ui/Tabs/Tab'
import Typography from 'material-ui/styles/typography';
import Paper from 'material-ui/Paper';
import Grid from 'material-ui/GridList/GridList';

//custom chart apis
import { LineChart, XAxis, Tooltip, CartesianGrid, Line } from 'recharts'
//custom comps
import FinChart from './FinChart';


export default class FinChartDash extends Component {
    state = {
        value: 0,
      };

render() {
      return (
                    <div className="FinChartDash">
                             <FinChart />
                    </div>
            )//
        }//render
}//class


// WEBPACK FOOTER //
// ./src/components/FinChartDash.js